import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';
import { modal } from '@/helpers/ui';
import { useUserStore } from '@/stores/user';

export default () => {
  const { t } = useI18n();

  const { mutate: requestTrialMutation } = useMutation(
    gql`
      mutation activateTrial($input: ActivateTrialInput!) {
        activateTrial(input: $input) {
          trialEndsAt
          errors
        }
      }
    `,
    {
      variables: {
        input: {
          moduleName: 'marketing',
        },
      },
    },
  );

  const requestTrial = () =>
    new Promise<void>((resolve, reject) => {
      modal('confirmation', {
        message: t('upgrade_subscription_page.start_trial_modal.title'),
        subMessage: t(
          'upgrade_subscription_page.start_trial_modal.description',
          brandName(),
        ),
      }).then(() => {
        requestTrialMutation()
          .then(() => {
            const { getUser } = useUserStore();
            getUser().finally(() => {
              resolve();
            });
          })
          .catch(() => {
            reject();
          });
      });
    });

  return {
    requestTrial,
  };
};
